import { Spinner } from 'baseui/spinner';
import stylesColors from 'common/styles/styles.colors';
import { DetailContainer } from 'components/styles';

interface Props {
  style?: React.CSSProperties;
}

export default function LoadingComponent(props: Props) {
  return (
    <DetailContainer style={props.style}>
      <Spinner $color={stylesColors.primaryDefault} />
    </DetailContainer>
  );
}
